import {
  Accordion,
  Checkbox,
  Form,
  Icon,
  Input,
  Select,
} from 'semantic-ui-react';
import { IFormDetails } from '../../../../../app/stores/dashboardConfiguration/types';
import { SyntheticEvent } from 'react';
import { useStore } from '../../../../../app/stores/store';
import { observer } from 'mobx-react-lite';
import { criteriaOptions } from '../../dataGrid/dropdownOptions';

function AccordionContent({
  activeIndex,
  index,
  options,
  name,
  handleMasterChange,
  metadataList,
  selectedMetadata,
  metadataHandler,
  masterElement,
  switchMode,
  flexBasis,
  setFlexBasis,
  isTable,
  changeComparision,
  addValue,
  removeCriteria,
  handleCriteria,
  showCriteria,
}: {
  activeIndex: number;
  index: number;
  options: any;
  name: string;
  handleMasterChange: any;
  metadataList: any;
  selectedMetadata: any;
  metadataHandler: any;
  masterElement: any;
  switchMode: any;
  flexBasis: any;
  setFlexBasis: any;
  isTable?: boolean;
  changeComparision?: (
    _event: any,
    data: any,
    id: string,
    index: number,
  ) => void;
  addValue?: (
    _event: any,
    data: any,
    id: string,
    type: string | undefined,
    index: any,
  ) => void;
  removeCriteria?: (id: string, index: any) => void;
  handleCriteria?: (id: any) => void;
  showCriteria?: {
    elementId: string;
    criteria: { type: string; value: string }[];
  }[];
}) {
  const { DashboardConfigurationStore } = useStore();

  return (
    <Accordion.Content active={activeIndex === index}>
      <div style={{ marginBottom: '12px' }}>
        <label>Set Width</label>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginTop: '10px',
          }}
        >
          <input
            type="range"
            min="0"
            max="100"
            value={flexBasis}
            onChange={(e) => setFlexBasis(e.target.value)}
          />
          <span>{flexBasis !== '0' && flexBasis}</span>
        </div>
      </div>
      <Form style={{ marginTop: 0 }}>
        <Form.Field
          label={'Select Master'}
          control={Select}
          placeholder={'Select Master'}
          clearable
          fluid
          search
          selection
          options={options}
          onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
            if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
              e.stopPropagation();
          }}
          style={{ marginTop: '5px' }}
          value={name || ''}
          onChange={handleMasterChange}
        />
        {name !== 'Items' && (
          <Form.Field
            label={'Select Metadata'}
            control={Select}
            placeholder={'Select Metadata'}
            clearable
            fluid
            search
            selection
            multiple
            options={metadataList || []}
            onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
              if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                e.stopPropagation();
            }}
            style={{ marginTop: '5px' }}
            upward
            value={selectedMetadata || []}
            onChange={metadataHandler}
          />
        )}
        <div className="dashboardConfigMetadataSelection">
          {masterElement !== '[]' &&
            masterElement !== undefined &&
            JSON.parse(masterElement || '[]')?.map((data: IFormDetails) => {
              return (
                <>
                  {data.mode !== 2 && data.mode !== undefined && (
                    <div>
                      <Form.Field
                        control={Input}
                        value={data.elementName}
                        readOnly
                      />
                      <span>
                        <span className="disable-checkbox">
                          <Checkbox
                            name="isDisabled"
                            onClick={(_e: SyntheticEvent) => {
                              switchMode(data);
                            }}
                            label="Disable"
                            checked={data.mode !== 1}
                          />
                        </span>
                      </span>
                      {isTable && (
                        <>
                          <span
                            className="data-grid-set-criteria"
                            onClick={() => handleCriteria?.(data.elementId)}
                          >
                            Set Criteria
                          </span>
                          {(showCriteria
                            ?.map((crit: { elementId: any }) => crit.elementId)
                            .includes(data.elementId) ||
                            data.criteria !== undefined) && (
                            <>
                              {data?.criteria?.map((crit, index) => {
                                return (
                                  <>
                                    <div className="show-criteria">
                                      <Select
                                        placeholder="Select comparision"
                                        options={criteriaOptions}
                                        // onChange={changeComparision}
                                        value={crit?.type}
                                        onChange={(
                                          _e: any,
                                          comparisonData: any,
                                        ) =>
                                          changeComparision?.(
                                            _e,
                                            comparisonData,
                                            data.elementId,
                                            index,
                                          )
                                        }
                                      />
                                      <Input
                                        placeholder="Enter Value"
                                        value={crit?.value}
                                        onChange={(_e: any, valueData: any) =>
                                          addValue?.(
                                            _e,
                                            valueData,
                                            data.elementId,
                                            crit.type,
                                            index,
                                          )
                                        }
                                      />
                                      <Icon
                                        name="close"
                                        onClick={() =>
                                          removeCriteria?.(
                                            data.elementId,
                                            index,
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </>
              );
            })}
        </div>
        {isTable && (
          <Form.Field
            label={'Select Table Link Name'}
            control={Select}
            placeholder={'Table Link Name'}
            clearable
            fluid
            search
            selection
            options={metadataList || []}
            onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
              if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                e.stopPropagation();
            }}
            style={{ marginTop: '5px' }}
            upward
            value={DashboardConfigurationStore.tableWithForm.tableLinkName}
            onChange={(_e: any, data: any) => {
              DashboardConfigurationStore.tableWithForm.tableLinkName =
                data.value;
            }}
          />
        )}
      </Form>
    </Accordion.Content>
  );
}

export default observer(AccordionContent);
